import { useUserRolePermissionStore } from "contexts/RootStore.context";
import useDevice from "hooks/useDevice";
import usePageVisibility from "hooks/usePageVisibility";
import { useEffect, useRef } from "react";
import { MapStore } from "stores/MapStore";


export default function usePolling(pollingTime: number, mapStoreObj: MapStore) {

  const { isMobileDevice } = useDevice();
  const { windowIsVisible } = usePageVisibility();
  const { canViewAssets, canViewUsers, canViewDevices } = useUserRolePermissionStore()
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (!windowIsVisible) return;
    let isCancelled = false;

    const poll = async () => {
      const promises: Promise<any>[] = [];
      try {
        // Fetch users (only if not on mobile)
        if (!isMobileDevice && canViewUsers && mapStoreObj.showUserMarkers) {
          promises.push(mapStoreObj.loadUsers())
        }

        if (canViewAssets && mapStoreObj.showAssetMarkers) {
          promises.push(mapStoreObj.loadAssets())
        }

        if (!isMobileDevice && canViewDevices && mapStoreObj.showDeviceMarkers) {
          promises.push(mapStoreObj.loadDevices())
        }

        await Promise.all(promises);

      } catch (error) {
        console.error('Polling error:', error);
      }

      // Schedule the next poll only after data load completes
      if (!isCancelled) {
        timerRef.current = setTimeout(poll, pollingTime * 1000);
      }
    };

    // Start polling immediately
    poll();

    return () => {
      isCancelled = true;
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [windowIsVisible, isMobileDevice, canViewAssets, canViewUsers, pollingTime, mapStoreObj, canViewDevices,
    mapStoreObj.showDeviceMarkers, mapStoreObj.showAssetMarkers, mapStoreObj.showUserMarkers
  ]);
}